module.exports = __webpack_public_path__ + "media/images/2024_fanclub_card_child-ccad1e4a22edcd96817430730c565512.png";